import React, { useState, useEffect } from "react";
import MyDataTable from "../../component/MyDataTable";
import { Link, NavLink } from "react-router-dom";
import Select from "react-select";
import httpRequest from "../../utils/Http";
import { toast } from "react-toastify";
import {
  getdropdownList,
  getPartWarranty,
  openSignUrl,
} from "../../utils/HelperFunction";
import { UploadFileToS3 } from "../../utils/S3File";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { EMPLOYEE_TYPE } from "../../constant/status_constant";

const ReverseChallanTab = ({ setReload, reloadList }) => {
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);
  const [formData, setFormData] = useState({});
  const [isOpenForm, setOpenForm] = useState(false);
  const [courierNamelist, setCourierNameList] = useState([]);
  const [isSubmit, setSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [courierDate, setCourierDate] = useState();

  const rejectReverseChallan = async (msl_id) => {
    const data = await httpRequest("rejectreversechallan", { msl_id }, "POST");

    if (data.status === true && data.message) {
      toast.success(data.message);
      setReload(true);
    } else {
      toast.error(data.message);
    }
  };

  const closeForm = () => {
    setOpenForm(false);
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: "Service Center",
      selector: (row) => row.sender_service_center.display_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Challan</div>,
      selector: (row) => row.msl_id,
      cell: (row) => (
        <Link
          to={"javascript:void(0)"}
          onClick={() => openSignUrl(row.main_file)}
        >
          {row.msl_id}
        </Link>
      ),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Challan Date</div>,
      selector: (row) => new Date(row.msl_date).toDateString(),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Quantity</div>,
      selector: (row) => row.quantity,
      wrap: true,
    },
    {
      name: "Basic Amount",
      selector: (row) => row.taxable_value,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Gst Amount</div>,
      selector: (row) => row.gst_amount,
      wrap: true,
    },
    // {
    //   name: <div className="word-wrap">Invoice/Challan</div>,
    //   selector: (row) => (Number(row.is_invoice) === 1 ? "Invoice" : "Challan"),
    //   wrap: true,
    // },
    {
      name: "Reverse Challan",
      cell: (row) =>
        Number(row.is_invoice) !== 1 && (
          <button
            className="btn btn-danger btn-sm"
            onClick={(e) => {
              rejectReverseChallan(row.id);
            }}
          >
            Reject
          </button>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
    {
      name: "Courier Update",
      cell: (row) => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            setFormData({ challan_id: row.id });
            setOpenForm(true);
          }}
        >
          Dispatch
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  const conditionalRowStyles = [
    {
      when: (row) => row.rejection_date_for_sf,
      style: {
        color: "red",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  useEffect(() => {
    (async () => {
      getdropdownList(setCourierNameList, `getcouriernamelist?is_active=1`);
    })();
    //eslint-disable-next-line
  }, []);

  const validateForm = (value) => {
    const errors = {};

    if (!value.challan_id) {
      errors.challan_number = "Challan Number is Required";
    }

    if (!value.courier_name) {
      errors.courier_name = "Courier Name is Required";
    }

    if (!value.awb_number) {
      errors.awb_number = "AWB Number is Required";
    }

    if (!value.remarks) {
      errors.remarks = "Remarks is Required";
    }

    if (!value.courier_price) {
      errors.courier_price = "Courier Price is Required";
    }

    if (!value.courier_date) {
      errors.courier_date = "Courier Date is Required";
    }

    if (value.courierRead !== true && !value.courier_file) {
      errors.courier_file = "Courier File is Required";
    }

    return errors;
  };

  useEffect(() => {
    if (formData.awb_number && formData.courier_name) {
      (async () => {
        setFormData({ ...formData, courierRead: false });
        const courier = await httpRequest(
          `checkcourierexist`,
          {
            awb_number: formData.awb_number,
            courier_name: formData.courier_name,
          },
          "POST",
        );

        if (courier.status === true && courier.data) {
          setFormData({
            ...formData,
            courier_price: courier.data.courier_price,
            courier_date: courier.data.shippment_date,
            courierRead: true,
          });
          setCourierDate(courier.data.shippment_date);
        } else if (courier.status === false) {
          toast.error(courier.message);
          setFormData({
            ...formData,
            courier_name: null,
            awb_number: "",
          });
        }
      })();
    }
  }, [formData.courier_name, formData.awb_number]);

  // Function to handle form submission
  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(true);
    setFormErrors(validateForm(formData));
    setSubmit(true);
  };

  // Effect to submit form data when no errors and isSubmit is true
  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        let postData = { ...formData };

        if (formData.courier_file) {
          const courier_file = await UploadFileToS3(
            "docFile",
            formData.courier_file,
          );
          postData.courier_file = courier_file;
        }

        const data = await httpRequest(
          "updatecourierreversechallan",
          postData,
          "POST",
        );

        setSubmit(false);
        if (data.status === true && data.message) {
          document.getElementById("courierupdate").reset();
          closeForm();
          toast.success(data.message);
          setFormData({});
          setCourierDate("");
          setReload(true);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmit]);

  const formAddUpdate = () => {
    return (
      <>
        <div className="form-overlay">
          <div className="form-container">
            <div className="form-content">
              <form id="courierupdate" onSubmit={onSubmitHandler}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card" style={{ marginBottom: "0px" }}>
                      <div className="card-header">
                        <h3 className="card-title">Update Shippment</h3>
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={closeForm}
                          style={{ float: "right" }}
                        >
                          X
                        </button>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Courier *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.courier_name}
                                </span>
                              </label>
                              <Select
                                name="courier_name"
                                value={
                                  courierNamelist.find(
                                    (option) =>
                                      option.label === formData.courier_name,
                                  ) || null
                                }
                                options={courierNamelist}
                                onChange={(val) => {
                                  setFormData({
                                    ...formData,
                                    courier_name: val.label,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                AWB Number *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.awb_number}
                                </span>
                              </label>
                              <input
                                type="text"
                                name="awb_number"
                                value={formData.awb_number}
                                className="form-control"
                                placeholder="Enter AWB Number"
                                onChange={(val) => {
                                  setFormData({
                                    ...formData,
                                    awb_number: val.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Courier Price *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.courier_price}
                                </span>
                              </label>
                              <input
                                type="number"
                                min={0}
                                value={formData.courier_price}
                                readOnly={
                                  formData.courierRead === true ? true : false
                                }
                                name="courier_name"
                                className="form-control"
                                placeholder="Enter Docket NUmber"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    courier_price: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Courier Date *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.courier_date}
                                </span>
                              </label>
                              <DatePicker
                                className="form-control text-capitalize"
                                minDate={
                                  new Date(
                                    new Date().setDate(
                                      new Date().getDate() - 7,
                                    ),
                                  )
                                }
                                maxDate={
                                  new Date(
                                    new Date().setDate(new Date().getDate()),
                                  )
                                }
                                dateFormat="dd/MM/yyyy"
                                selected={courierDate}
                                readOnly={
                                  formData.courierRead === true ? true : false
                                }
                                placeholderText="Select Courier Date"
                                onChange={(date) => {
                                  setFormData({
                                    ...formData,
                                    courier_date: date,
                                  });
                                  setCourierDate(date);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Courier invoice file *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.courier_file}
                                </span>
                              </label>
                              <input
                                type="file"
                                name="courier_file"
                                readOnly={
                                  formData.courierRead === true ? true : false
                                }
                                className="form-control"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    courier_file: e.target.files[0],
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>
                                Remarks *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.remarks}
                                </span>
                              </label>
                              <input
                                type="text"
                                name="remarks"
                                className="form-control"
                                value={formData.remarks}
                                placeholder="Enter Remarks"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    remarks: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="card-footer text-center"
                        style={{
                          marginBottom: "60px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary col-md-12"
                          style={{ marginLeft: "0px" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Dispatch Reverse Challan</h3>
                </div>
                <MyDataTable
                  reloadList={reloadList}
                  columns={columns}
                  getDataListURL={`getreversechallannotdispatched?isdefective=1`}
                  setReload={setReload}
                  exportName={"partordered"}
                  conditionalRowStyles={conditionalRowStyles}
                />
              </div>
            </div>
          </div>
        </div>
        {isOpenForm && formAddUpdate()}
      </section>
    </div>
  );
};

export default ReverseChallanTab;
